// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export { strShimFunction, strShimObject, strShimUndefined, strShimPrototype, strShimHasOwnProperty, strDefault, ObjClass, ObjProto, ObjAssign, ObjCreate, ObjDefineProperty, ObjHasOwnProperty } from "./Constants";
export { throwTypeError, objCreateFn, getGlobal } from "./Helpers";
export { __assignFn, __extendsFn, __restFn, __spreadArrayFn, __spreadArraysFn, __decorateFn, __paramFn, __metadataFn, __createBindingFn, __valuesFn, __readFn, __makeTemplateObjectFn, __importDefaultFn, __importStarFn, __exportStarFn } from "./TsLibShims";
export { __exposeGlobalTsLib } from "./TsLibGlobals";
//# sourceMappingURL=applicationinsights-shims.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-shims/dist-esm/applicationinsights-shims.js
// module id = 14
// module chunks = 0